export default __webpack_public_path__ + "static/media/logo-light.f0fb0325.svg";